// extracted by mini-css-extract-plugin
export default {"root":"Search_root__PbbMw","input":"Search_input__NZEoX","icon":"Search_icon__gDEwf","clearIcon":"Search_clearIcon__40Fk6"};